import { useCreateCloseNotesMutation } from 'app/services/projects';
import { Drawers } from 'app/types/drawer';
import NotesForm from './NotesForm';
import { Modal } from 'antd';
import { useTranslation } from 'react-i18next';

type CreateNotesProps = {
  projectId: number
};

const CreateNotes = ({ projectId }: CreateNotesProps) => {
  const [ close, meta ] = useCreateCloseNotesMutation();
  const { t } = useTranslation();

  const handleSubmit = async (values: any) => {
    Modal.confirm({
      title: t('forms.workplace.close'),
      onOk: async () => await close(
        {
          ProjectId: projectId,
          Comments: {
            CloseNotes: values.CloseNotes,
            QuantitiesComments: values.QuantitiesComments,
            SafetyComments: values.SafetyComments,
            OtherComments: values.OtherComments
          },
          ReportType: values.ReportType,
          ReportLanguage: values.ReportLanguage
        })
    });
  };

  return <NotesForm
    formId={Drawers.ADD_NOTES}
    handleSubmit={handleSubmit}
    meta={meta}
  />;
};

export default CreateNotes;